import gql from 'graphql-tag';
import { Company360FullFragment } from '../fragments/Company360FullFragment';

export const Company360CreateMutation = gql`
	mutation Company360CreateMutation($values: Company360CreateInput!) {
		results: company360Create(values: $values) {
			...Company360FullFragment
		}
	}
	${Company360FullFragment}
`;